/**
 * Limites do espaço da logo no BPe/voucher (CSS .logo img { width: 120px }).
 * Imagens mais altas que largas ou maiores que o cabeçalho esticam o documento.
 */
export const TICKET_LOGO = {
  mimeTypes: ["image/png", "image/jpeg"],
  maxBytes: 400 * 1024,
  maxWidth: 800,
  maxHeight: 240,
  minWidth: 80,
  minHeight: 24,
  /** largura / altura: quadrada (~1) até faixa horizontal */
  minAspect: 0.9,
  maxAspect: 5,
};

export const TICKET_LOGO_HINT =
  "PNG ou JPG, horizontal ou quadrada, no máximo 800 × 240 px e 400 KB.";

export function ticketLogoRejection({ type, size, width, height, name } = {}) {
  const mime = String(type || "").toLowerCase();
  const fileName = String(name || "").toLowerCase();
  const extOk = /\.(png|jpe?g)$/i.test(fileName);
  const mimeOk = TICKET_LOGO.mimeTypes.includes(mime) || mime === "image/jpg";
  if (fileName && !extOk && !mimeOk) {
    return "Use um arquivo PNG ou JPG.";
  }
  if (mime && !mimeOk && !/^image\//i.test(mime) && !extOk) {
    return "Use um arquivo PNG ou JPG.";
  }
  if (mime && /^image\//i.test(mime) && !mimeOk) {
    return "Este formato não cabe no bilhete. Envie PNG ou JPG.";
  }
  if (Number(size) > TICKET_LOGO.maxBytes) {
    return "A imagem precisa ter no máximo 400 KB.";
  }
  const w = Number(width);
  const h = Number(height);
  if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
    return "Não foi possível ler o tamanho da imagem.";
  }
  if (w < TICKET_LOGO.minWidth || h < TICKET_LOGO.minHeight) {
    return "A imagem é pequena demais. Use pelo menos 80 × 24 pixels.";
  }
  if (w > TICKET_LOGO.maxWidth || h > TICKET_LOGO.maxHeight) {
    return "A logo cabe no cabeçalho com no máximo 800 × 240 pixels. Reduza a imagem e envie de novo.";
  }
  const aspect = w / h;
  if (aspect < TICKET_LOGO.minAspect) {
    return "Use uma logo na horizontal ou quadrada. Imagens altas esticam o bilhete.";
  }
  if (aspect > TICKET_LOGO.maxAspect) {
    return "A imagem é larga demais para o cabeçalho. Use uma logo mais compacta.";
  }
  return null;
}
